import {
  ComputeOptions,
  computeValue
} from "../../core";
const $first = (collection, expr, options) => {
  if (collection.length === 0) return void 0;
  const copts = ComputeOptions.init(options).update(collection[0]);
  return computeValue(collection[0], expr, null, copts);
};
export {
  $first
};
